import { parse, format } from 'url'
import React from 'react'
import PropTypes from 'prop-types'
import Immutable from 'immutable'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import {
  CX,
  DEFAULT_REL,
  PREVIEW_CARD_GAB_CONTENT_TYPE_GROUP,
  PREVIEW_CARD_GAB_CONTENT_TYPE_FEED,
  PREVIEW_CARD_GAB_CONTENT_TYPE_MARKETPLACE_LISTING,
} from '../constants'
import {
  decodeIDNA,
  getHostname,
  trim,
} from '../utils/urls'
import ResponsiveClassesComponent from '../features/ui/util/responsive_classes_component'
import Icon from './icon'
import Button from './button'
import Text from './text'
import { withRouter } from 'react-router-dom'

const domParser = new DOMParser()

const addAutoPlay = html => {
  const document = domParser.parseFromString(html, 'text/html').documentElement
  const iframe = document.querySelector('iframe')

  if (iframe) {
    if (iframe.src.indexOf('?') !== -1) {
      iframe.src += '&'
    } else {
      iframe.src += '?'
    }

    iframe.src += 'autoplay=1&auto_play=1'

    // DOM parser creates html/body elements around original HTML fragment,
    // so we need to get innerHTML out of the body and not the entire document
    return document.querySelector('body').innerHTML
  }

  return html
}

class StatusCard extends ImmutablePureComponent {

  state = {
    width: this.props.defaultWidth || 280,
    embedded: false,
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!Immutable.is(this.props.card, nextProps.card)) {
      this.setState({ embedded: false })
    }
  }

  handlePhotoClick = () => {
    const { card, onOpenMedia } = this.props

    onOpenMedia(
      Immutable.fromJS([
        {
          type: 'image',
          url: card.get('embed_url'),
          description: card.get('title'),
          meta: {
            original: {
              width: card.get('width'),
              height: card.get('height'),
            },
          },
        },
      ]),
      0
    )
  }

  handleEmbedClick = () => {
    const { card } = this.props

    if (card.get('type') === 'photo') {
      this.handlePhotoClick()
    } else {
      this.setState({ embedded: true })
    }
  }

  setRef = c => {
    if (c) {
      this.setState({ width: c.offsetWidth })
    }
  }

  renderVideo() {
    const { card } = this.props
    const content = { __html: addAutoPlay(card.get('html')) }
    const { width } = this.state
    const ratio = card.get('width') / card.get('height')
    const height = width / ratio

    return (
      <div
        ref={this.setRef}
        className={[_s.d, _s.bgTertiary, _s.posAbs, _s.top0, _s.right0, _s.bottom0, _s.left0, _s.statusCardVideo].join(' ')}
        dangerouslySetInnerHTML={content}
      />
    )
  }

  render() {
    const {
      card,
      isReduced,
      isVertical,
      isBorderless,
      isImageSmall,
      blurhashOnly,
    } = this.props
    const { width, embedded } = this.state

    if (card === null) return null

    const maxTitle = 160
    const maxDescription = isReduced ? 160 : 200
    let cardImg = card.get('image')
    const isMarketplaceListing = card.get('gab_content_type') === PREVIEW_CARD_GAB_CONTENT_TYPE_MARKETPLACE_LISTING

    if (card.get('width') > 800 && !!cardImg && (process.env.NODE_ENV === 'production' || [true, "true", 1, "1"].includes(process.env.CF_RESIZE))) {
      const parts = parse(cardImg)
      const previewWidth = card.get('type') === 'video' ? 720 : 240
      const resizePart = `/cdn-cgi/image/width=${previewWidth},quality=100,fit=scale-down`
      //parts.pathname = `${resizePart}${parts.pathname}`
      //cardImg = format(parts)
    }
    const provider = card.get('provider_name').length === 0 ? decodeIDNA(getHostname(card.get('url'))) : card.get('provider_name')
    const interactive = card.get('type') !== 'link'
    const isOnLinkFeed = `${window.location.pathname}`.indexOf('/links/') > -1
    const isOnMediaPage = `${window.location.pathname}`.indexOf('/media/') > -1

    const imgContainerClasses = CX({
      d: 1,
      h200PX: 1,
      w340PX: !isVertical,
    })
    
    const cardTitle = trim(card.get('title') || '', maxTitle)
    const title = interactive ?
      (
        <a
          className={[_s.d, _s.displayFlex, _s.text, _s.noUnderline, _s.overflowWrapBreakWord, _s.cPrimary, _s.fs15PX, _s.fw500].join(' ')}
          href={card.get('url')}
          title={cardTitle}
          rel={DEFAULT_REL}
          target='_blank'
        >
          {cardTitle}
        </a>
      )
      : (
        <span className={[_s.d, _s.displayFlex, _s.text, _s.overflowWrapBreakWord, _s.cPrimary, _s.fs15PX, _s.fw500].join(' ')}>
          {cardTitle}
        </span>
      )

    const description = (
      <div className={[_s.d, _s.flexNormal, _s.px10, _s.py10, _s.overflowHidden, _s.borderColorSecondary, _s.borderLeft1PX].join(' ')}>
        {title}
        {
          !isImageSmall &&
          <p className={[_s.d, _s.displayFlex, _s.text, _s.mt5, _s.mb5, _s.overflowWrapBreakWord, _s.cSecondary, _s.fs13PX, _s.fw400].join(' ')}>
            {trim(card.get('description') || '', maxDescription)}
          </p>
        }
        {
          !isMarketplaceListing &&
          <span className={[_s.d, _s.mtAuto, _s.flexRow, _s.flexWrap, _s.aiCenter, _s.displayFlex, _s.textOverflowEllipsis].join(' ')}>
            <Icon id='link' size='10px' className={[_s.cSecondary, _s.mr5].join(' ')} fixedWidth />
            <Text color='secondary' size='small' className={[_s.mrAuto, _s.whiteSpaceNoWrap, _s.overflowHidden, _s.maxW100PC130PX, _s.textOverflowEllipsis2].join(' ')}>
              {provider}
            </Text>
            {
              !isOnLinkFeed &&
              <Button
                isNarrow
                color='secondary'
                backgroundColor='secondary'
                to={`/links/${card.get('id')}`}
                className={_s.px10}
              >
                <Text color='inherit' size='extraSmall'>Link Feed</Text>
              </Button>
            }
          </span>
        }
        {
          isMarketplaceListing &&
          <div className={[_s.d, _s.w100PC, _s.mtAuto].join(' ')}>
            <Button
              isBlock
              radiusSmall
              href={card.get('url')}
              rel={DEFAULT_REL}
            >
              <Text align='center' weight='medium' color='inherit'>View on Gab Marketplace</Text>
            </Button>
          </div>
        }
      </div>
    )

    const responsiveThumbnail = (
      <ResponsiveClassesComponent
        classNames={imgContainerClasses}
        classNamesSmall={[_s.d, _s.h260PX, _s.w100PC].join(' ')}
        classNamesXS={[_s.d, _s.h200PX, _s.w100PC].join(' ')}
      >
        <img loading='lazy' alt={''} src={cardImg} className={[_s.d, _s.objectFitCover, _s.w100PC, _s.h100PC].join(' ')} />
      </ResponsiveClassesComponent>
    )

    const smallThumbnailClasses = CX({
      d:1,
      h106PX: !isOnMediaPage,
      w192PX: !isOnMediaPage,
      h115PX: isOnMediaPage,
      w100PC: isOnMediaPage,
    })

    const smallThumbnail = (
      <div className={smallThumbnailClasses}>
        <img loading='lazy' alt={''} src={cardImg} className={[_s.d, _s.objectFitCover, _s.w100PC, _s.h100PC].join(' ')} />
      </div>
    )

    // : todo : use <Image />
    let embed = ''
    const thumbnail = interactive ?
      <img loading='lazy' alt={''} src={cardImg} className={[_s.d, _s.objectFitCover, _s.posAbs, _s.w100PC, _s.h100PC, _s.top0, _s.right0, _s.bottom0, _s.left0].join(' ')} />
      : isImageSmall ?
      smallThumbnail
      : responsiveThumbnail
      

    const innerContainerClasses = CX({
      d: 1,
      overflowHidden: 1,
      w100PC: 1,
      borderColorSecondary: !isBorderless,
      border1PX: !isBorderless,
      radiusSmall: !isBorderless,
      cursorPointer: !interactive,
      noUnderline: !interactive,
      bgSubtle_onHover: !interactive,
      flexRow: interactive && isImageSmall && !embedded,
    })
    
    if (interactive) {
      if (embedded) {
        embed = this.renderVideo()
      }

      let iconVariant = 'play'

      if (card.get('type') === 'photo') {
        iconVariant = 'search-plus'
      }

      const embedWrapperClasses = CX({
        d: 1,
        w100PC: !isImageSmall || embedded,
        w192PX: isImageSmall && !embedded,
      })

      return (
        <div className={[_s.d, _s.w100PC].join(' ')}>
          <div className={innerContainerClasses}>
            {
              !isReduced &&
              <div className={embedWrapperClasses}>
                <div className={[_s.d, _s.w100PC, _s.pt5625PC].join(' ')}>
                  {!!embed && embed}
                  {!embed && thumbnail}
                  {!embed &&
                    <div className={[_s.d, _s.posAbs, _s.top0, _s.right0, _s.left0, _s.bottom0, _s.aiCenter, _s.jcCenter].join(' ')}>
                      <button
                        className={[_s.d, _s.cursorPointer, _s.bgBlackOpaquer, _s.radiusSmall, _s.py15, _s.px15].join(' ')}
                        onClick={this.handleEmbedClick}
                      >
                        <Icon id={iconVariant} size='22px' className={_s.cWhite} />
                      </button>
                    </div>
                  }
                </div>
              </div>
            }
            {description}
          </div>
        </div>
      )
    } else if (cardImg) {
      embed = (
        <div className={[_s.d].join(' ')}>
          {thumbnail}
        </div>
      )
    } else {
      embed = (
        <div className={[_s.d, _s.py15, _s.px15, _s.w72PX, _s.aiCenter, _s.jcCenter].join(' ')}>
          <Icon id='website' size='22px' className={_s.cSecondary} />
        </div>
      )
    }

    const containerClasses = CX({
      d: 1,
      w100PC: 1,
      flexRow: !isVertical && !isOnMediaPage,
    })

    return (
      <div className={[_s.d, _s.w100PC].join(' ')}>
        <a
          href={card.get('url')}
          rel={DEFAULT_REL}
          ref={this.setRef}
          target='_blank'
          className={innerContainerClasses}
        >
          <ResponsiveClassesComponent
            classNames={containerClasses}
            classNamesSmall={!cardImg ? undefined : [_s.d, _s.w100PC].join(' ')}
          >
            {!isReduced && embed}
            {description}
          </ResponsiveClassesComponent>
        </a>
      </div>
    )
  }

}

StatusCard.propTypes = {
  card: ImmutablePropTypes.map,
  onOpenMedia: PropTypes.func.isRequired,
  defaultWidth: PropTypes.number,
  isReduced: PropTypes.bool,
  isVertical: PropTypes.bool,
  isImageSmall: PropTypes.bool,
  isBorderless: PropTypes.bool,
}

export default StatusCard
